<script setup lang="ts">
import { modifyDate } from '@/shared/utils/modifyTime';
import { LAWYER_INFO } from '@/pages/lawyer/model/keys';

const isMobile: boolean = useIsMobile();
const lawyerInfo = inject(LAWYER_INFO);

const practices = computed(() => lawyerInfo?.value?.legalPractice ?? []);
</script>

<template>
  <div :class="['arbitrage-practice-block', { _mobile: isMobile }]">
    <ul v-if="practices.length" class="arbitrage-practice-block__list">
      <li
        v-for="practice in practices"
        :key="practice.id"
        class="arbitrage-practice-block__item"
      >
        <div class="arbitrage-practice-block__summary">
          <div class="arbitrage-practice-block__header">
            <div class="arbitrage-practice-block__date">
              Дата: <span>{{ modifyDate(practice.date) }}</span>
            </div>
            <div class="arbitrage-practice-block__case">
              № дела: <span>{{ practice.external_identifier }}</span>
            </div>
          </div>
          <div class="arbitrage-practice-block__content">
            <div class="arbitrage-practice-block__content-title">Суть дела:</div>
            <div class="arbitrage-practice-block__content-caption">
              {{ practice.text }}
            </div>
          </div>
        </div>
        <div class="arbitrage-practice-block__result">
          <div class="arbitrage-practice-block__content">
            <div class="arbitrage-practice-block__content-title">Результат:</div>
            <div class="arbitrage-practice-block__content-caption">
              {{ practice.result }}
            </div>
          </div>
          <a
            v-if="practice.document"
            class="arbitrage-practice-block__link"
            :href="practice.document"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ссылка на дело
          </a>
        </div>
      </li>
    </ul>
    <div v-else class="arbitrage-practice-block__empty">
      Автор профиля пока не указал информацию о судебных делах
    </div>
  </div>
</template>

<style lang="less">
.arbitrage-practice-block {
  &__item {
    .flex-column(56px);

    padding: @size-x5 0;

    &:first-child {
      padding-top: 0;
    }

    &:not(:last-child) {
      border-bottom: 1px solid @color-gallery;
    }
  }

  &__summary {
    .flex-column(@size-x5);
  }

  &__result {
    .flex-column(@size-x6);
  }

  &__date {
    margin-bottom: 5px;
  }

  &__date,
  &__case {
    font-size: @size-x3;
    line-height: @size-x4;
    font-weight: 500;
    color: @color-dove-gray;

    span {
      color: @color-elephant;
      font-weight: 600;
    }
  }

  &__content-caption {
    font-size: @size-x4;
    line-height: 22px;
    font-weight: 400;
    color: @color-dove-gray;
  }

  &__content-title {
    font-weight: 700;
    font-size: @size-x4;
    line-height: 22px;
    margin-bottom: 5px;
  }

  &__link {
    position: relative;
    align-self: flex-start;
    color: @color-persimmon;
    font-weight: 600;
    font-size: @size-x3;
    line-height: @size-x4;
    letter-spacing: 0.41px;

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      border-radius: 2px;
      background-color: @color-persimmon;
    }
  }

  &__empty {
    font-weight: 500;
  }

  &._mobile &__item {
    gap: @size-x6;
  }

  &._mobile &__content-caption {
    font-size: 14px;
    line-height: 21px;
  }
}
</style>
